import "./customSlider.css";
import calendarImg from "../../picture/7.png";
import Button from "../../Custom/Button/Button";
import SendIcon from "@mui/icons-material/Send";
import NotificationCalendar from "./NotificationCalendar";
import playLeft from "../../picture/play-left.png";
import playRight from "../../picture/play-right.png";
import send from "../../picture/send.png";
import pescanik from "../../picture/pescanik.png";

import bellImg from "../../picture/zvono.png";
import SliderAlarm from "./SliderAlarm";
import Slider from "./Slider";
import { useEffect, useRef, useState } from "react";
import {
  getDay,
  format,
  getMonth,
  startOfMonth,
  endOfMonth,
  compareAsc,
  eachDayOfInterval,
} from "date-fns";
import CustomTimer from "./CustomTimer";
import { ReadMore } from "@mui/icons-material";

const CustomSlider = ({
  currentActive,
  setCurrentActive,
  currentNotification,
  notificationsList,
  setNotificationsList,
  setCurrentNotification,
  setNotifications,
  isFromSliderRef,
  notifications,
  setIsEditing,
  isEditing,
}) => {
  const handleSelectDate = () => {
    let currentDate;
    if (isEditing) {
      if (currentActive === 2) {
        currentDate = new Date(
          currentNotification.alarms[0] || currentNotification.date
        );
      } else {
        currentDate = new Date(currentNotification.date);
      }
    } else {
      if (currentActive === 2 && currentNotification.alarms.length !== 0) {
        currentDate = new Date(currentNotification.alarms[0]);
      } else {
        currentDate =
          notificationsList.length !== 0
            ? new Date(notificationsList[0].date)
            : new Date();
      }
    }
    return currentDate;
  };

  const [selectedDate, setSelectedDate] = useState(handleSelectDate());

  const endDay = new Date(endOfMonth(selectedDate).setHours(0, 0, 0, 0));
  const startDay = new Date(startOfMonth(selectedDate).setHours(0, 0, 0, 0));
  let correctDates = [];
  if (isEditing) {
    if (currentActive === 2) {
      let newDates = currentNotification.alarms.map((alarm) => {
        return new Date(new Date(alarm).setHours(0, 0, 0, 0));
      });
      const newCorrectDates = [
        ...new Set(
          newDates.map((newDate) => `${format(newDate, "yyyy-MM-dd")}`)
        ),
      ];
      newDates = newCorrectDates.map((alarm) => {
        return new Date(new Date(alarm).setHours(0, 0, 0, 0));
      });
      correctDates = newDates;
    } else {
      correctDates = new Date(currentNotification.date);
    }
  } else {
    if (notificationsList.length !== 0) {
      if (
        currentNotification.alarms.length === 0 ||
        notificationsList.length > 1
      ) {
        correctDates = notificationsList.map((item) => {
          return new Date(new Date(item.date).setHours(0, 0, 0, 0));
        });
      } else {
        let newDates = currentNotification.alarms.map((alarm) => {
          return new Date(new Date(alarm).setHours(0, 0, 0, 0));
        });
        const newCorrectDates = [
          ...new Set(
            newDates.map((newDate) => `${format(newDate, "yyyy-MM-dd")}`)
          ),
        ];
        newDates = newCorrectDates.map((alarm) => {
          return new Date(new Date(alarm).setHours(0, 0, 0, 0));
        });
        correctDates = newDates;
      }
    } else {
      correctDates.push(new Date(new Date().setHours(0, 0, 0, 0)));
    }
  }

  const handleAlarmTime = () => {
    return currentNotification.alarmTime;

    /*
    let date = new Date(
      currentNotification.alarms[currentNotification.alarms.length - 1]
    );
    if (currentNotification.alarms.length === 0) {
      return "";
    } else return format(date, "hh:mm");*/
  };

  const handleRemainders = () => {
    let active = [];
    let timerHours;
    let timerMinutes;
    let newActive = [];

    if (currentNotification.startTime !== "") {
      timerHours = currentNotification.startTime.split(":")[0];
      timerMinutes = currentNotification.startTime.split(":")[1];
    } else {
      timerHours = currentNotification.endTime.split(":")[0];
      timerMinutes = currentNotification.endTime.split(":")[1];
    }

    if (notificationsList.length === 1) {
      let newAlarms = currentNotification.alarms.filter(
        (alarm) =>
          compareAsc(
            new Date(new Date(alarm).setHours(0, 0, 0, 0)),
            new Date(new Date(notificationsList[0].date).setHours(0, 0, 0, 0))
          ) === 0
      );
      let alarmLength = newAlarms.length;
      if (
        newAlarms.length !== 0 &&
        newAlarms[newAlarms.length - 1].getHours() ===
          parseInt(currentNotification.alarmTime.split(":")[0]) &&
        newAlarms[newAlarms.length - 1].getMinutes() ===
          parseInt(currentNotification.alarmTime.split(":")[1])
      ) {
        alarmLength -= 1;
      }
      for (let i = 0; i < alarmLength; i++) {
        let newAlarmsMinute = newAlarms[i].getMinutes();
        let newAlarmsHours = newAlarms[i].getHours();

        let finishHours = parseInt(timerHours) - parseInt(newAlarmsHours);
        let finishMinutes = parseInt(timerMinutes) - parseInt(newAlarmsMinute);
        active.push(
          format(
            new Date(new Date().setHours(finishHours, finishMinutes, 0, 0)),
            "HH:mm"
          )
        );
      }
      newActive = active.map((item) => {
        let hours = parseInt(item.split(":")[0]);
        let minutes = parseInt(item.split(":")[1]);
        return hours * 60 + minutes;
      });
    } else {
      let newAlarms = currentNotification.alarms;
      let alarmLength = newAlarms.length;
      if (
        newAlarms.length !== 0 &&
        newAlarms[newAlarms.length - 1].getHours() ===
          parseInt(currentNotification.alarmTime.split(":")[0]) &&
        newAlarms[newAlarms.length - 1].getMinutes() ===
          parseInt(currentNotification.alarmTime.split(":")[1])
      ) {
        alarmLength -= 1;
      }
      for (let i = 0; i < alarmLength; i++) {
        let newAlarmsMinute = newAlarms[i].getMinutes();
        let newAlarmsHours = newAlarms[i].getHours();

        let finishHours = parseInt(timerHours) - parseInt(newAlarmsHours);
        let finishMinutes = parseInt(timerMinutes) - parseInt(newAlarmsMinute);
        active.push(
          format(
            new Date(new Date().setHours(finishHours, finishMinutes, 0, 0)),
            "HH:mm"
          )
        );
      }
      newActive = active.map((item) => {
        let hours = parseInt(item.split(":")[0]);
        let minutes = parseInt(item.split(":")[1]);
        return hours * 60 + minutes;
      });
    }
    return newActive;
  };

  const handleSetSelectedAlarms = () => {
    let selected = [];
    notificationsList.forEach((notification) => {
      if (notification.alarms.length !== 0)
        selected.push(
          new Date(new Date(notification.date).setHours(0, 0, 0, 0))
        );
    });
    return selected;
  };

  const [selectedDates, setSelectedDates] = useState(correctDates);
  const [calendarSelected, setCalendarSelected] = useState(false);
  const [reminders, setReminders] = useState(handleRemainders());
  const [alarmTime, setAlarmTime] = useState(handleAlarmTime());
  const [selectedAlarms, setSelectedAlarms] = useState(
    handleSetSelectedAlarms()
  );

  const timeAlarm = [
    { text: "5", value: 5 },
    { text: "10", value: 10 },
    { text: "15", value: 15 },
    { text: "30", value: 30 },
    { text: "60", value: 60 },
    { text: "2H", value: 120 },
    { text: "3H", value: 180 },
  ];

  const days = [
    "NEDELJA",
    "PONEDELJAK",
    "UTORAK",
    "SREDA",
    "CETVRTAK",
    "PETAK",
    "SUBOTA",
  ];

  const handleSelectDay = (isDirection) => {
    if (
      isDirection === false &&
      compareAsc(
        new Date(new Date(selectedDate).setHours(0, 0, 0, 0)),
        new Date(new Date().setHours(0, 0, 0, 0))
      ) === 0
    )
      return;
    if (currentActive === 2) {
      if (isEditing) {
        let firstNotification = new Date(
          new Date(currentNotification.date).setHours(0, 0, 0, 0)
        );
        if (
          isDirection &&
          compareAsc(
            new Date(new Date(selectedDate).setHours(0, 0, 0, 0)),
            firstNotification
          ) === 0
        )
          return;
      } else {
        let firstNotification = new Date(
          new Date(notificationsList[0].date).setHours(0, 0, 0, 0)
        );
        if (
          isDirection &&
          compareAsc(
            new Date(new Date(selectedDate).setHours(0, 0, 0, 0)),
            firstNotification
          ) === 0
        )
          return;
      }
    }
    let currentMonth;
    if (!isDirection && compareAsc(startDay, selectedDate) === 0) {
      currentMonth = getMonth(selectedDate) - 1;
      const correctDay = `${format(selectedDate, "yyyy")}-${
        currentMonth + 1
      }-${format(selectedDate, "dd")}`;
      const tempDate = new Date(correctDay);
      const newEndDay = endOfMonth(tempDate);
      const newCorrectDate = `${format(selectedDate, "yyyy")}-${
        currentMonth + 1
      }-${format(newEndDay, "dd")}`;
      setSelectedDates([
        new Date(new Date(newCorrectDate).setHours(0, 0, 0, 0)),
      ]);
      setSelectedDate(new Date(new Date(newCorrectDate).setHours(0, 0, 0, 0)));
    } else if (isDirection && compareAsc(endDay, selectedDate) === 0) {
      currentMonth = getMonth(selectedDate) + 1;
      const correctDay = `${format(selectedDate, "yyyy")}-${
        currentMonth + 1
      }-01`;
      setSelectedDates([new Date(new Date(correctDay).setHours(0, 0, 0, 0))]);
      setSelectedDate(new Date(new Date(correctDay).setHours(0, 0, 0, 0)));
    } else {
      let day;
      if (isDirection) {
        day = parseInt(format(selectedDate, "dd")) + 1;
      } else {
        day = parseInt(format(selectedDate, "dd")) - 1;
      }
      const correctDay = `${format(selectedDate, "yyyy")}-${format(
        selectedDate,
        "MM"
      )}-${day}`;
      setSelectedDates([new Date(new Date(correctDay).setHours(0, 0, 0, 0))]);
      setSelectedDate(new Date(new Date(correctDay).setHours(0, 0, 0, 0)));
    }
    //setCalendarSelected(true);
  };

  const handleSubmitNotification = () => {
    if (currentActive === 1) {
      let startTime = currentNotification.startTime.split(":");
      let endTime = currentNotification.endTime.split(":");
      let startTimeMinutes =
        parseInt(startTime[0]) * 60 + parseInt(startTime[1]);
      let endTimeMinutes = parseInt(endTime[0]) * 60 + parseInt(endTime[1]);

      if (isEditing) {
        setCurrentNotification({ ...currentNotification, date: selectedDate });
        setCurrentActive(2);
      } else if (
        (currentNotification.startTime !== "" &&
          currentNotification.endTime === "") ||
        (currentNotification.startTime === "" &&
          currentNotification.endTime !== "") ||
        (currentNotification.startTime !== "" &&
          currentNotification.endTime !== "")
      ) {
        let newNotificationList;
        if (
          currentNotification.endTime !== "" &&
          currentNotification.startTime === ""
        ) {
          newNotificationList = selectedDates.map((item, index) => {
            return {
              ...currentNotification,
              date: item,
              id: notifications.length + index + 1,
              isFromSlider: isFromSliderRef.current,
              startTime: currentNotification.endTime,
              endTime: "",
            };
          });
        } else if (endTimeMinutes < startTimeMinutes) {
          newNotificationList = selectedDates.map((item, index) => {
            return {
              ...currentNotification,
              date: item,
              startTime: currentNotification.endTime,
              endTime: currentNotification.startTime,
              id: notifications.length + index + 1,
              isFromSlider: isFromSliderRef.current,
            };
          });
        } else {
          newNotificationList = selectedDates.map((item, index) => {
            return {
              ...currentNotification,
              date: item,
              id: notifications.length + index + 1,
              isFromSlider: isFromSliderRef.current,
            };
          });
        }
        setNotificationsList(newNotificationList);
        if (currentActive === 5) setCurrentActive(2);
        else setCurrentActive(currentActive + 1);
      }
    }
    if (currentActive === 2) {
      let minutesAlarm;
      let hoursAlarm;
      if (currentNotification.startTime !== "") {
        minutesAlarm = currentNotification.startTime.split(":")[1];
        hoursAlarm = currentNotification.startTime.split(":")[0];
      } else {
        minutesAlarm = currentNotification.endTime.split(":")[1];
        hoursAlarm = currentNotification.endTime.split(":")[0];
      }
      let alarms = [];
      let time = [];
      let alarmTimes = [];
      let newNotificationList = [];
      if (isEditing) {
        selectedDates.forEach((notification) => {
          reminders.forEach((alarm) => {
            let correctAlarmHours = hoursAlarm - parseInt(alarm / 60);
            let correctAlarmMinutes = minutesAlarm - (alarm % 60);
            if (correctAlarmMinutes < 0) {
              correctAlarmHours -= 1;
              correctAlarmMinutes = 60 + correctAlarmMinutes;
            }
            alarms.push(
              new Date(
                new Date(notification).setHours(
                  correctAlarmHours,
                  correctAlarmMinutes,
                  0,
                  0
                )
              )
            );
          });
          alarms.push(
            new Date(
              new Date(notification).setHours(hoursAlarm, minutesAlarm, 0, 0)
            )
          );
        });

        setCurrentNotification({ ...currentNotification, alarms, alarmTime });
        setCurrentActive(0);
        let newNotifications = notifications.map((notification) => {
          if (notification.id === currentNotification.id)
            return { ...currentNotification, alarms };
          else return notification;
        });
        setNotifications(newNotifications);
      } else {
        if (notificationsList.length === 1) {
          reminders.forEach((alarm) => {
            let correctAlarmHours = hoursAlarm - parseInt(alarm / 60);
            let correctAlarmMinutes = minutesAlarm - (alarm % 60);
            if (correctAlarmMinutes < 0) {
              correctAlarmHours -= 1;
              correctAlarmMinutes = 60 + correctAlarmMinutes;
            }
            alarms.push(
              new Date(
                new Date(notificationsList[0].date).setHours(
                  correctAlarmHours,
                  correctAlarmMinutes,
                  0,
                  0
                )
              )
            );
          });
          if (alarmTime !== "") {
            let minutesAlarm = alarmTime.split(":")[1];
            let hoursAlarm = alarmTime.split(":")[0];
            selectedDates.map((selectDate) => {
              let correctAlarmHours = hoursAlarm;
              let correctAlarmMinutes = minutesAlarm;
              if (correctAlarmMinutes < 0) {
                correctAlarmHours -= 1;
                correctAlarmMinutes = 60 + correctAlarmMinutes;
              }
              alarms.push(
                new Date(
                  new Date(selectDate).setHours(
                    correctAlarmHours,
                    correctAlarmMinutes,
                    0,
                    0
                  )
                )
              );
            });
          }
          newNotificationList = [
            { ...notificationsList[0], alarms, alarmTime },
          ];
          /* selectedDates.forEach((notification) => {
            reminders.forEach((alarm) => {
              let correctAlarmHours = hoursAlarm - parseInt(alarm / 60);
              let correctAlarmMinutes = minutesAlarm - (alarm % 60);
              if (correctAlarmMinutes < 0) {
                correctAlarmHours -= 1;
                correctAlarmMinutes = 60 + correctAlarmMinutes;
              }
              alarms.push(
                new Date(
                  new Date(notification).setHours(
                    correctAlarmHours,
                    correctAlarmMinutes,
                    0,
                    0
                  )
                )
              );
            });
            alarms.push(
              new Date(
                new Date(notification).setHours(hoursAlarm, minutesAlarm, 0, 0)
              )
            );
          });*/
        } else {
          alarmTimes = reminders.map((alarm) => {
            let correctAlarmHours = hoursAlarm - parseInt(alarm / 60);
            let correctAlarmMinutes = minutesAlarm - (alarm % 60);
            if (correctAlarmMinutes < 0) {
              correctAlarmHours -= 1;
              correctAlarmMinutes = 60 + correctAlarmMinutes;
            }
            return { correctAlarmHours, correctAlarmMinutes };
          });
          alarmTimes.push({
            correctAlarmHours: alarmTime.split(":")[0],
            correctAlarmMinutes: alarmTime.split(":")[1],
          });

          newNotificationList = notificationsList.map((notification, index) => {
            let isFound = selectedAlarms.find(
              (alarm) => compareAsc(alarm, new Date(notification.date)) === 0
            );
            if (isFound) {
              alarms = alarmTimes.map(
                (alarm) =>
                  new Date(
                    new Date(isFound).setHours(
                      alarm.correctAlarmHours,
                      alarm.correctAlarmMinutes,
                      0,
                      0
                    )
                  )
              );
              return { ...notification, alarms, alarmTime };
            } else return notification;
          });
        }

        setCurrentNotification({ ...currentNotification, alarms, alarmTime });
        setNotificationsList(newNotificationList);
        setCurrentActive(3);
      }
    }
    if (currentActive === 5) {
      const startHours = document.querySelector(".slider-timer-hours");
      const startMinutes = document.querySelector(".slider-timer-minutes");
      const endHours = document.querySelector(".slider-timer-hours-end");
      const endMinutes = document.querySelector(".slider-timer-minutes-end");

      let startTime = startHours.value + ":" + startMinutes.value;
      let endTime = endHours.value + ":" + endMinutes.value;

      if (startHours.value === "" || startMinutes.value === "") {
        return;
      } else if (endHours.value === "" || endMinutes.value === "") {
        endTime = "";
      }

      if (isEditing) {
        setCurrentNotification({
          ...currentNotification,
          startTime,
          endTime,
          isFromSlider: false,
        });
        isFromSliderRef.current = false;
        setCurrentActive(2);
      } else {
        setCurrentNotification({
          ...currentNotification,
          startTime,
          endTime,
          isFromSlider: false,
        });
        isFromSliderRef.current = false;
        const newNotificationList = selectedDates.map((item, index) => {
          return {
            ...currentNotification,
            id: notifications.length + index + 1,
            date: format(item, "yyyy-MM-dd"),
            startTime,
            endTime,
            isFromSlider: false,
          };
        });
        setNotificationsList(newNotificationList);
        setCurrentActive(2);
      }
    }
  };

  const handleCompareBell = () => {
    let isBell = false;
    if (currentActive === 2 && notificationsList.length > 1) {
      isBell = true;
    } else {
      isBell =
        compareAsc(
          new Date(new Date(selectedDate).setHours(0, 0, 0, 0)),
          new Date(new Date().setHours(0, 0, 0, 0))
        ) === 0;
    }
    return isBell;
  };

  const settingReminders = (reminder) => {
    const existingReminder = reminders.find((r) => r === reminder);
    let sortedReminders;
    if (existingReminder) {
      sortedReminders = reminders
        .filter((r) => existingReminder !== r)
        .sort((a, b) => b - a);
    } else {
      sortedReminders = [...reminders, reminder].sort((a, b) => b - a);
    }

    setReminders(sortedReminders);
  };

  const handleActiveButton = (time) => {
    let contain = false;
    if (isEditing) {
      //Edituj
      let active = [];
      let timerHours;
      let timerMinutes;
      let newActive = [];

      if (currentNotification.startTime !== "") {
        timerHours = currentNotification.startTime.split(":")[0];
        timerMinutes = currentNotification.startTime.split(":")[1];
      } else {
        timerHours = currentNotification.endTime.split(":")[0];
        timerMinutes = currentNotification.endTime.split(":")[1];
      }

      let newAlarms = currentNotification.alarms.filter(
        (alarm) =>
          compareAsc(
            new Date(new Date(alarm).setHours(0, 0, 0, 0)),
            new Date(new Date(currentNotification.date).setHours(0, 0, 0, 0))
          ) === 0
      );

      let alarmLength = newAlarms.length;
      if (
        newAlarms.length !== 0 &&
        newAlarms[newAlarms.length - 1].getHours() ===
          parseInt(currentNotification.alarmTime.split(":")[0]) &&
        newAlarms[newAlarms.length - 1].getMinutes() ===
          parseInt(currentNotification.alarmTime.split(":")[1])
      ) {
        alarmLength -= 1;
      }

      for (let i = 0; i < alarmLength; i++) {
        let newAlarmsMinute = newAlarms[i].getMinutes();
        let newAlarmsHours = newAlarms[i].getHours();

        let finishHours = parseInt(timerHours) - parseInt(newAlarmsHours);
        let finishMinutes = parseInt(timerMinutes) - parseInt(newAlarmsMinute);
        active.push(
          format(
            new Date(new Date().setHours(finishHours, finishMinutes, 0, 0)),
            "HH:mm"
          )
        );
      }
      newActive = active.map((item) => {
        let hours = parseInt(item.split(":")[0]);
        let minutes = parseInt(item.split(":")[1]);
        return hours * 60 + minutes;
      });

      if (newActive.filter((ac) => ac === time.value).length !== 0)
        contain = true;

      if (reminders.filter((ac) => ac === time.value).length !== 0)
        contain = true;
    } else {
      if (reminders.filter((ac) => ac === time.value).length !== 0)
        contain = true;
    }
    return contain;
  };

  return (
    <div className="wrapper-notification-slider">
      <div className="notification-change-time">
        <div
          className="notification-arrow-left"
          onClick={() => handleSelectDay(false)}
        >
          <img src={handleCompareBell() ? bellImg : playLeft} alt="" />
        </div>
        {(currentActive !== 2 ||
          notificationsList.length === 1 ||
          isEditing) && (
          <>
            <div className="notification-text-day">
              {days[getDay(selectedDate)]} {format(selectedDate, "dd.MM")}
            </div>
            <div
              className="notification-arrow-right"
              onClick={() => handleSelectDay(true)}
            >
              <img src={playRight} alt="" />
            </div>{" "}
          </>
        )}
      </div>
      {currentActive === 1 && (
        <Slider
          selectedDate={selectedDate}
          currentNotification={currentNotification}
          setCurrentNotification={setCurrentNotification}
          isFromSliderRef={isFromSliderRef}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
        />
      )}
      {currentActive === 2 && (
        <div className="slider-alarm-container">
          <SliderAlarm
            selectedDate={selectedDate}
            setAlarmTime={setAlarmTime}
            currentNotification={currentNotification}
            isEditing={isEditing}
            notificationsList={notificationsList}
          />
          <div className="alarm-container">
            <div className="alarm-time">
              <img src={pescanik} alt=""></img>
            </div>
            {timeAlarm.map((time, index) => {
              return (
                <div
                  className="alarm-time-button"
                  key={index}
                  onClick={() => settingReminders(time.value)}
                >
                  <Button active={handleActiveButton(time)}>
                    <div
                      className={
                        handleActiveButton(time)
                          ? "time-button checked"
                          : "time-button"
                      }
                    >
                      {time.text}
                    </div>
                  </Button>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {currentActive === 5 && (
        <CustomTimer
          selectedDate={selectedDate}
          currentNotification={currentNotification}
          setCurrentNotification={setCurrentNotification}
          isFromSliderRef={isFromSliderRef}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
        />
      )}
      <div className="notification-buttons">
        <div
          className="notification-button"
          onClick={() => setCalendarSelected(!calendarSelected)}
        >
          <Button image={calendarImg} />
        </div>
        <div
          className="notification-button"
          onClick={() => handleSubmitNotification()}
        >
          <Button activation={true} image={send} />
        </div>
      </div>
      {calendarSelected && (
        <NotificationCalendar
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          selectedDates={selectedDates}
          setSelectedDates={setSelectedDates}
          notificationsList={notificationsList}
          currentNotification={currentNotification}
          currentActive={currentActive}
          isEditing={isEditing}
          selectedAlarms={selectedAlarms}
          setSelectedAlarms={setSelectedAlarms}
        />
      )}
    </div>
  );
};

export default CustomSlider;
